export const REST_API = "https://aetu-be.onrender.com/api/v1/"
// export const REST_API = "http://localhost:8989/api/v1/"

export const LOGIN_VIEW = "/login"
export const CARD_VIEW = "/in/view"

export const LOCAL_LOCATION = "t";